import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray} from 'lodash';

import searchHoc from '../components-app/search-wrapper';

const servicesDataKey = 'featuredFolderListAll';

const featuredFolderList = ({onChange, value, id, searchData}) => {
    const flatFeaturedFolders = (folders, flattenFeaturedFolders) => {
        if (isArray(folders)) {
            folders.forEach(folder => {
                flattenFeaturedFolders.push({
                    label: folder.name,
                    value: Number(folder?.folderID),
                });
                flatFeaturedFolders(folder?.subFolders, flattenFeaturedFolders);
            });
        }
        return flattenFeaturedFolders;
    };

    return (
        <Dropdown
            filter={true}
            filterBy="label,value"
            filterPlaceholder="Select Featured Folder"
            id={id}
            options={flatFeaturedFolders(searchData?.featuredFolders, []).sort((prev, next) =>
                prev?.label || next?.label
                    ? !prev?.label
                        ? -1
                        : !next?.label
                        ? 1
                        : prev?.label.localeCompare(next?.label)
                    : 0
            )}
            showClear={false}
            style={{width: '300px'}}
            value={value}
            onChange={onChange}
        />
    );
};

featuredFolderList.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    searchData: PropTypes.object.isRequired,
    value: PropTypes.number.isRequired,
};

export default searchHoc(featuredFolderList, servicesDataKey);
